// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2gMy5","footer":"ModalFilter_footer__3bXbz"};